ui-cms-blog-comment-content {
  display: flex;
  padding-bottom: 1rem;

  .comment-icon {
    // UI Logo Icon is an img tag
    .ui-icon,
    img {
      border: 1px solid $sd-borderColor-neutral-400;
      border-radius: 50px;
      padding: 0.5rem;
      width: 3rem;
      height: 3rem;
    }
  }

  .comment-info {
    width: 100%;
    display: flex;
    flex-flow: column wrap;
    gap: 0.5rem;

    &__name,
    &__message,
    &__reply-to {
      padding: 0 1rem;
    }

    &__name {
      strong {
        margin-right: 1rem;
      }

      .date {
        font-size: 14px;
        color: $sd-textColor-neutral-600;
      }
    }

    &__reply-to {
      font-size: 14px;
      color: $sd-textColor-neutral-600;
    }

    sd-button {
      width: fit-content;

      sd-icon {
        font-size: 20px;
      }
    }
  }

  &.active {
    sd-button {
      margin-left: auto;
    }

    // override styles for the editor
    .buttons-container {
      &.is-editor {
        sd-button {
          margin-left: unset;
        }

        @include breakpoint($medium) {
          sd-button {
            margin-left: auto;
          }
        }
      }
    }
  }

  .buttons-container {
    display: flex;

    &.is-editor {
      background-color: $sd-backgroundColor-neutral-100;
      flex-flow: column wrap;
      align-items: flex-start;
      margin: 0 1rem;
      padding: 1rem 0.5rem;

      strong {
        padding-left: 1rem;
      }

      @include breakpoint($medium) {
        flex-direction: row;
        align-items: center;
        padding: 0 0.5rem;
      }

      .editor-controls {
        display: flex;
        flex-direction: column;

        @include breakpoint($medium) {
          margin-left: auto;
          display: unset;
        }
      }
    }
  }
}
